module.exports = __webpack_public_path__ + "img/qiyewenhua.eb7b1b03.png";